/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { keyBy, chain } from "lodash";

export class CaApi {
    constructor(api) {
        this.api = api;
        this._apenafs = null;
        this._territories = null;
    }

    async getAllTerritories() {
        if (this._territories) {
            return this._territories;
        }
        const items = await this.api.get("/territories?size=200");
        this._territories = items._embedded.territories;
        return this._territories;
    }

    async getAllApenafs() {
        if (this._apenafs) {
            return this._apenafs;
        }
        const response = await this.api.get("/apenafs?size=10000");
        this._apenafs = keyBy(response._embedded.apenafs, i => i.code);
        return this._apenafs;
    }

    async getApenafsNot2025() {
        const nafs = await this.getAllApenafs();
        return chain(nafs)
            .values()
            .filter(i => i.type != "N2025")
            .keyBy(i => i.code)
            .value();
    }

    async getApenafs2008() {
        const nafs = await this.getAllApenafs();
        return chain(nafs)
            .values()
            .filter(i => i.type === "N2008")
            .keyBy(i => i.code)
            .value();
    }

    async getApenafs2025() {
        const nafs = await this.getAllApenafs();
        return chain(nafs)
            .values()
            .filter(i => i.type === "N2025")
            .keyBy(i => i.code)
            .value();
    }
}
